import { useSyncExternalStore } from 'react';
import { useSettings } from '../state/settingsStore.ts';

const QUERY = '(prefers-reduced-motion: reduce)';

function subscribe(onChange: () => void): () => void {
  if (typeof matchMedia !== 'function') return () => undefined;
  const mql = matchMedia(QUERY);
  mql.addEventListener('change', onChange);
  return () => {
    mql.removeEventListener('change', onChange);
  };
}

const getSnapshot = (): boolean => typeof matchMedia === 'function' && matchMedia(QUERY).matches;

/** Effective "reduce motion": the explicit setting, or the operating system when unset. */
export function useReducedMotion(): boolean {
  const system = useSyncExternalStore(subscribe, getSnapshot, () => false);
  const setting = useSettings().accessibility.reduceMotion;
  return setting ?? system;
}

/** Subscribes to a CSS media query. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof matchMedia !== 'function') return () => undefined;
      const mql = matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => {
        mql.removeEventListener('change', onChange);
      };
    },
    () => typeof matchMedia === 'function' && matchMedia(query).matches,
    () => false,
  );
}
